export default "__VITE_ASSET__Dd_zhYd4__"